import { render, staticRenderFns } from "./OperaBannerZhuanquWindow.vue?vue&type=template&id=28126d09&scoped=true&"
import script from "./OperaBannerZhuanquWindow.vue?vue&type=script&lang=js&"
export * from "./OperaBannerZhuanquWindow.vue?vue&type=script&lang=js&"
import style0 from "./OperaBannerZhuanquWindow.vue?vue&type=style&index=0&id=28126d09&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28126d09",
  null
  
)

export default component.exports